module.exports = __webpack_public_path__ + "static/media/047-man-13.6d5d2a17.svg";